import { render, staticRenderFns } from "./TransactionConfigDetail.vue?vue&type=template&id=adcae3de&scoped=true&"
import script from "./TransactionConfigDetail.vue?vue&type=script&lang=js&"
export * from "./TransactionConfigDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adcae3de",
  null
  
)

export default component.exports